'use client';
import { makeNavigationSiteAnalytics } from '@/services/simpleApis';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';

interface IssuersIndexNavigationProps {
    prevIssuerLink: string;
    nextIssuerLink: string;
}

const IssuersIndexNavigation = ({ prevIssuerLink, nextIssuerLink }: IssuersIndexNavigationProps): JSX.Element => {
    return (
        <div className="d-flex align-items-center justify-content-between justify-content-xxl-start gap-4 ms-lg-2 col-11 col-lg-auto mt-2 mt-lg-0">
            {prevIssuerLink && (
                <Link
                    href={prevIssuerLink}
                    className="fw-semibold no-underline text-xs"
                    onClick={() => makeNavigationSiteAnalytics('Prev button', '/issuers')}
                >
                    <span className="d-flex align-items-center gap-1">
                        <FontAwesomeIcon icon={faArrowLeft} size="xs" className="border border-2 border-primary p-1 rounded" />{' '}
                    </span>
                </Link>
            )}
            {nextIssuerLink && (
                <Link
                    href={nextIssuerLink}
                    className="fw-semibold no-underline text-xs"
                    onClick={() => makeNavigationSiteAnalytics('Next button', '/issuers')}
                >
                    <span className="d-flex align-items-center gap-1">
                        <FontAwesomeIcon icon={faArrowRight} size="xs" className="border border-2 border-primary p-1 rounded" />{' '}
                    </span>
                </Link>
            )}
        </div>
    );
};

export default IssuersIndexNavigation;
